module.exports = __webpack_public_path__ + "static/media/RTM.e18ec7c7.png";